module.exports = __webpack_public_path__ + "static/media/bruce2.ef5062b2.mp3";